import { callApi } from '../common/services/baseServices';
import { host, env } from '../environment';
import { getCookie } from '../common/enum';
import axios from '../axios';

const ACTIONS = {
  GET_JSON: 'GET_JSON',
  SHOW_LOADING: 'SHOW_LOADING',
  LOGIN_PROGRESS: 'LOGIN_PROGRESS',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGIN_ERROR: 'LOGIN_ERROR',
  GET_ROLE_SUCCESS: "GET_ROLE_SUCCESS",
  GET_ROLE_ERROR: "GET_ROLE_ERROR"
};

const updateStatus = (type, data) => ({
  type,
  data,
});

const login = (data) => {
  const config = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      accept: 'application/json',
      'X-CSRF-TOKEN': '',
    },
    body: JSON.stringify({
      grant_type: 'password',
      client_id: '2',
      client_secret: env.clientSecret,
      username: data.email, // test-account+1@i3design.co.jp
      password: data.password, // password1
      refresh_token: '',
    }),
  };
  return (dispatch) => {
    updateStatus(ACTIONS.LOGIN_PROGRESS, true);
    callApi(`${host.serverTest}oauth/token`, config,
      (res) => {
        // console.log(res)
        axios.defaults.headers.common['Authorization'] = `Bearer ${res.access_token}`;
        dispatch(updateStatus(ACTIONS.LOGIN_SUCCESS, res));
      },
      (err) => {
        dispatch(updateStatus(ACTIONS.LOGIN_ERROR, err));
      });
  };
};

const getRoleUser = (token) => {

  const config = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}` || `Bearer ${localStorage.getItem('ACCESS_TOKEN') ||
        getCookie('ACCESS_TOKEN')}`,
    },
  };
  let url = `${host.serverTest}api/me`;
  return (dispatch) => {
    callApi(url, config,
      (data) => {
        dispatch(updateStatus(ACTIONS.GET_ROLE_SUCCESS, {
          id: data.id ? data.id : null,
          role: data.role ? data.role.id : null,
          menus: data.menus || []
        }));
      },
      (err) => {
        dispatch(updateStatus(ACTIONS.GET_ROLE_ERROR, err));
      });
  };

  // return (dispatch) => {
  //   dispatch(updateStatus(ACTIONS.GET_ROLE_SUCCESS, {
  //     role: 2
  //   }));
  // };
}

const getCurrentRole = () => {
  return async () => {
    const {data} = await axios.get(`api/me`);
    return data;
  };
}

export { login, ACTIONS, getRoleUser, getCurrentRole };
